<template>
  <v-container fluid fill-height class="login">
    <v-row align="center" justify="center">
      <v-col cols="10" sm="7" md="10" lg="7">
        <v-card class="elevation-12" color="#00000000">
          <v-row>
            <v-col class="login-form pa-12" md="5" lg="5">
              <div class="my-auto" style="width: 100%">
                <v-text-field solo :label="$t(`username`)" append-icon="mdi-account" v-model="username"
                  @keyup.enter="login()" :rules="[rules.requiredUsername]" tabindex="1"></v-text-field>

                <v-text-field solo :label="$t(`password`)" append-icon="mdi-lock" :prepend-inner-icon="
                  showPasswordText ? 'mdi-eye' : 'mdi-eye-off'
                " @keyup.enter="login()" v-model="password" :rules="[rules.requiredPass]"
                  :type="showPasswordText ? 'text' : 'password'"
                  @click:prepend-inner="showPasswordText = !showPasswordText" tabindex="2"></v-text-field>

                <v-btn color="primary" block @click="login()" :disabled="disableLogin" tabindex="3">
                  <span v-if="this.loading">
                    <v-progress-circular indeterminate color="white" left width="3" size="25"></v-progress-circular>
                  </span>
                  <span v-else>
                    {{ $t("login") }}
                  </span>
                </v-btn>

                <div class="d-flex ma-2">
                  <v-spacer></v-spacer>
                  <small class="color-Version">{{ $t("version") }} : {{ $appVersion }}</small>
                </div>
                <v-row v-if="showActivwDirectory">
                  <!-- سوییچ اکتیو دایرکتوری  -->
                 
          <v-switch
              :loading="loadingEnableActiveDir"
              :disabled="disableActiveDir"
              dense
              inset
              
              v-model="swActiveDir"
              color="teal"
              @change="changeActiveDir"
            >
            <template v-slot:label>
              <span class="color-Version">{{ $t("EnterByActiveDirectory") }} </span>
            </template>
          
            </v-switch>
         
        </v-row>

                <LocaleSwitcher :color="'#c9d0da'" />

                <div v-if="lblError" class="text-center pt-3">
                  <span class="error--text">{{ lblError }}</span>
                </div>
                <div>
                  <v-icon>mdi-settings</v-icon>
                </div>
              </div>
            </v-col>
            <v-col class="d-md-flex flex-column description-form hidden-sm-and-down" md="7" lg="7">
              <div class="pa-12">
                <p class="text-start" :class="[
                  'border-blue',
                  $vuetify.rtl ? 'title-text-right' : 'title-text-left',
                ]">
                  {{ $t("login-side-panel-title-1") }}
                </p>
                <p class="text-start" :class="[
                  'border-yellow',
                  $vuetify.rtl ? 'title-text-right' : 'title-text-left',
                ]">
                  {{ $t("login-side-panel-title-2") }}
                </p>
                <p class="text-start" :class="[
                  'border-green',
                  $vuetify.rtl ? 'title-text-right' : 'title-text-left',
                ]">
                  {{ $t("login-side-panel-title-3") }}
                </p>
              </div>
              <small class="mt-auto py-2 px-3">
                حضور و غیاب علم و صنعت
                <a target="_blank" href="https://www.elmosanat.com">www.elmosanat.com
                </a>
              </small>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <!-- \\add -->
    <v-row justify="center">
      <!-- <v-btn
      color="primary"
      dark
      @click.stop="dialog = true"
    >
      Open Dialog
    </v-btn> -->

      <v-dialog v-if="dialogShow" v-model="dialog" max-width="400">
        <v-card class="red">
          <v-card-title class="text-h5 font-h5" style="
    font-family: 'Sahel';
    font-family: 'Sahel', Helvetica, Arial !important;">
            نسخه وینکارت به روزرسانی نشده است!
          </v-card-title>

          <v-card-text class="show-color">
            <!-- این امر موجب اختلال در برنامه می شود. -->
            <!-- لطفا پس از به روز رسانی وینکارت  با مدیر وینکارت  لاگین کنید. -->
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>


          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <domain-login-name-dialog ref="DomainLoginNameDialog" @changeDomainLoginName="changeDomainLoginName" />
  </v-container>
</template>

<script>
//import { mapActions } from "vuex";
import LocaleSwitcher from "../../components/widget/LocaleSwitcher.vue";
import EosUtils from "../../utils/EosUtils";
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
import TextUtils from "../../utils/TextUtils";
import DomainLoginNameDialog from "../../components/auth/DomainLoginNameDialog.vue";

export default {
  components: {
    LocaleSwitcher,
    DomainLoginNameDialog,
  },
  data() {
    return {
      dialogShow: false,
      showActivwDirectory: false,
      swActiveDir:false,
      dialog: true,
      hasError: false,
      lblError: "",
      disableLogin: true,
      username: "",
      password: "",
      // HasActiveDir:false,
      // loginType:0,
      loading: false,
      showPasswordText: false,
      lockData: {},
      rules: {
        requiredPass: (value) => !!value || this.$t("required-pass-msg"),
        requiredUsername: (value) =>
          !!value || this.$t("required-username-msg"),
      },
    };
  },
  mounted() {
    this.pageLoad();
    this.getCustomerName();
    
  },
  methods: {
    showDialog() {

      this.dialogShow = true
    },
    async getCustomerName() {
      var GetCustomerNameResponse = await this.$store.dispatch(
        "lock/GetCustomerName"
      );
      if (GetCustomerNameResponse.type == ResultType.success) {
        //infoDataSet.companyName = GetCustomerNameResponse.data;
        console.log("getCustomerName:", GetCustomerNameResponse.data);
        //document.title = GetCustomerNameResponse.data;
        this.$store.state.lock.customerName = GetCustomerNameResponse.data
      }
    },
    async pageLoad() {
      // if (this.$isMobile()) {
      //   this.HasActiveDir = false
      // } else {
      //   this.HasActiveDir = true
      // }
      localStorage.removeItem('manage');
      localStorage.removeItem('newItem');
      this.lblError = "";
      this.loading = true;
      this.hasError = false;
      ////debugger
      ////debugger;
      // var checkWinKart = await this.$store.dispatch("IsWinkartUpToDate");

      // if (checkWinKart.type != ResultType.success) {
      //   if(checkWinKart.data==true){
      //     this.showDialog();

      //   }

      //   console.log(checkWinKart)

      // }
      ////debugger;

      var canConnectRes = await this.$store.dispatch("EosTestConnection");
      // //debugger
      if (await canConnectRes.type != ResultType.success) {
        // if ((await this.CheckTest())) {

        this.$EosToast.show({
          type: EosToastType.error,
          msg: "آدرس سرور نادرست می باشد",
        });
        this.loading = false;
        this.disableLogin = false;
        this.hasError = true;
        this.lblError = "آدرس سرور نادرست می باشد";
        ////debugger;

        return;
      }
      else {

        var EosCheckConfig = await this.$store.dispatch("EosTestPass");
        var hasActiveYearDbRes = await this.$store.dispatch("hasActiveYearDb");
        if (EosCheckConfig.type != ResultType.success) {
          //debugger;
          this.$router.push({ name: "config" });
         }
         else if (hasActiveYearDbRes.type == ResultType.success) {
          if (!hasActiveYearDbRes.data) {
            this.lblError = this.$t("eosWinKartWebResource.WorkInYearDbNotFound");
            this.loading = false;
            this.hasError = true;
            //return;
          }
          else {
            await this.$store.dispatch("NeedUpdateDB").then((NeedUpdateDBRes) => {
              if (NeedUpdateDBRes.type == ResultType.success) {
                if (NeedUpdateDBRes.data) {
                  this.lblError = this.$t("eosWinKartWebResource.UpdateDatabase");
                  this.hasError = true;
                  this.loading = false;
                  this.disableLogin = false;
                  //return;
                }
              } else {
                // this.lblError = this.$t("server-error");
                this.lblError = "پایگاه داده نیاز به بروزرسانی دارد";
                this.loading = false;
                this.hasError = true;
                //return;
              }
            });

          }
        } 
        else {
          ////debugger;

          this.lblError = "EosCheckConfig"+this.$t("server-error");
          this.loading = false;
          this.hasError = true;
          //return;
        }


        if (hasActiveYearDbRes.type != ResultType.success) {
          ////debugger;
          this.lblError ="hasActiveYearDbRes :"+ this.$t("server-error");
          // this.loading = false;
          // this.hasError = true;
          this.loading = true;
          this.hasError = false;

        } else {
          if (!hasActiveYearDbRes.data) {
            this.lblError = this.$t("eosWinKartWebResource.WorkInYearDbNotFound");
            this.loading = false;
            this.hasError = true;
            //return;
          }
          else {
            // await this.$store.dispatch("NeedUpdateDB").then((NeedUpdateDBRes) => {
            var NeedUpdateDBRes = await this.$store.dispatch("NeedUpdateDB");
            if (NeedUpdateDBRes.type != ResultType.success) {
              // this.lblError = this.$t("server-error");
              this.lblError = "پایگاه داده نیاز به بروزرسانی دارد";
              this.loading = false;
              this.hasError = true;
              //return;

            } else {
              if (NeedUpdateDBRes.data) {
                this.lblError = this.$t("eosWinKartWebResource.UpdateDatabase");
                this.hasError = true;
                this.loading = false;
                this.disableLogin = false;
                //return;
              }
              else {

                // var EosTestPassRes = await this.$store.dispatch("EosTestPass");
                // if (EosTestPassRes.type != ResultType.success) {
                //   //debugger;
                //   this.$router.push({ name: "config" });
                // } else {
                // if (!( this.CheckLock())) {
                //cc
                var canTestConnectRes = await this.$store.dispatch("EosTestConnection");
                if (canTestConnectRes.type != ResultType.success) {

                  this.$EosToast.show({
                    type: EosToastType.error,
                    msg: "آدرس سرور نادرست می باشد",
                  });
                  this.loading = false;
                  this.disableLogin = false;
                  this.hasError = true;
                  this.lblError = "آدرس سرور نادرست می باشد";
                  ////debugger;

                  return false;
                }
                else {

                  var isLockActiveRes = await this.$store.dispatch("lock/IsLockActive");
                  //console.log(isLockActiveRes);
                  // //debugger;
                  if (isLockActiveRes.type != ResultType.success) {
                    ////debugger
                    ////debugger;
                    this.lblError = " خطا در خواندن قفل ";
                    this.disableLogin = false;
                    this.loading = false;
                    this.hasError = true;
                    return false;
                  } else {
                    if (!isLockActiveRes.data) {
                      ////debugger
                      this.disableLogin = false;
                      this.lblError = "قفل وینکارت فعال نیست";
                      this.loading = false;
                      this.hasError = true;
                      return false;
                    }
                    else {
                      var lockDataRes = await this.$store.dispatch("lock/GetLockData");
                      console.log(lockDataRes);
                      if (lockDataRes.type != ResultType.success) {
                        this.lblError = " خطا در خواندن اطلاعات قفل ";
                        this.loading = false;
                        this.hasError = true;
                        this.disableLogin = false;
                        return false;

                      }
                      else {
                        var checkWinKart = await this.$store.dispatch("IsWinkartUpToDate");
                        ////debugger;

                        if (checkWinKart.type == ResultType.success) {
                          if (checkWinKart.data != true) {
                            this.showDialog();

                          }
                        }
                       

                        if (lockDataRes.type == ResultType.success) {
                          this.lockData = lockDataRes.data[0];
                          ////debugger
                        if (this.lockData.HasActiveDirectoryLogin == "True") {
                          //debugger
                          var hasActiveDirectory = false;
                          await this.$store.dispatch("lock/hasActiveDirectory").then((result) => {
                            //console.log(result);
                            if (result.type == ResultType.success) {
                              hasActiveDirectory = result.data;
                            }
                          });
                          if (hasActiveDirectory) {
                            var domainLoginName = localStorage.getItem("userActive");
                            if (domainLoginName) {
                              this.$router.push({ name: "home" });
                              // this.loginWithDomainLoginName(domainLoginName);
                            } else {
                              //show dialog get domainLoginName
                              // this.$refs.DomainLoginNameDialog.show();
                              this.showActivwDirectory=true
                            }
                          }
                        }

////debugger;
console.log("hdk:"+this.lockData)
                          if (this.lockData.HasWebRequest == "True") {
                            if (this.$isMobile()) {
                              //mobile
                              if (this.lockData.HasWebRequestMobile == "True") {
                                this.disableLogin = false;
                                this.loading = false;
                                return true;
                              } else {
                                this.lblError = " مجوز استفاده از موبایل در قفل برای شما فعال نیست";
                                this.loading = false;
                                this.disableLogin = false;
                                this.hasError = true;
                                return false;
                              }
                            } else {
                              //web
                              if (this.lockData.HasWebRequestDesktop == "True") {
                                this.loading = false;
                                this.disableLogin = false;
                                this.disableLogin = false;
                                return true;


                              } else {
                                this.lblError = " مجوز استفاده از وب در قفل برای شما فعال نیست";
                                this.loading = false;
                                this.disableLogin = false;
                                this.hasError = true;
                                return false;
                              }
                            }
                          } else {
                            this.lblError = " مجوز استفاده از وبکارت در قفل برای شما فعال نیست";
                            this.loading = false;
                            this.disableLogin = false;
                            this.hasError = true;
                            return false;
                          }



                        }

                      }

                    }
                  }
                }




                // else {
                //   var hasActiveYearDbRes = await this.$store.dispatch("hasActiveYearDb");
                //   if (hasActiveYearDbRes.type == ResultType.success) {
                //     if (!hasActiveYearDbRes.data) {
                //       this.lblError = this.$t("eosWinKartWebResource.WorkInYearDbNotFound");
                //       this.hasError = true;
                //       //return;
                //     }
                //     else {
                //       await this.$store.dispatch("NeedUpdateDB").then((NeedUpdateDBRes) => {
                //         if (NeedUpdateDBRes.type == ResultType.success) {
                //           if (NeedUpdateDBRes.data) {
                //             this.lblError = this.$t("eosWinKartWebResource.UpdateDatabase");
                //             this.hasError = true;
                //             this.loading = false;
                //             this.disableLogin = false;
                //             //return;
                //           }
                //         } else {
                //           // this.lblError = this.$t("server-error");
                //           this.lblError = "پایگاه داده نیاز به بروزرسانی دارد";
                //           this.hasError = true;
                //           //return;
                //         }
                //       });

                //     }
                //   } else {
                //     this.lblError = this.$t("server-error");
                //     this.hasError = true;
                //     //return;
                //   }
                // }
                // }

              }

            }
            // });

          }
          //return;
        }



        //////


        this.loading = false;

      }



      this.loading = false;
      this.disableLogin = false;
    },
    changeDomainLoginName(domainLoginName) {
      this.loginWithDomainLoginName(domainLoginName);
    },
    loginWithDomainLoginName(domainLoginName) {
      this.$store
        .dispatch("lock/IsValidDomainLoginName", {
          params: { domainUser: domainLoginName },
        })
        .then((result) => {
          if (result.response) {
            this.$router.push({ name: "home" });
          } else {
            localStorage.removeItem("domainLoginName");
          }
        });
    },
    async CheckTest() {
      var canConnectRes = await this.$store.dispatch("EosTestConnection");
      ////debugger
      if (await canConnectRes.type != ResultType.success) {

        this.$EosToast.show({
          type: EosToastType.error,
          msg: "آدرس سرور نادرست می باشد",
        });
        this.loading = false;
        this.disableLogin = false;
        this.hasError = true;
        this.lblError = "آدرس سرور نادرست می باشد";
        ////debugger;

        return true;

      }
      else {
        ////debugger
        return false;
      }
    },
    CheckLock() {
      //cc
      ////debugger;

      var canConnectRes = this.$store.dispatch("EosTestConnection");
      // //debugger
      if (canConnectRes.type != ResultType.success) {

        this.$EosToast.show({
          type: EosToastType.error,
          msg: "آدرس سرور نادرست می باشد",
        });
        this.loading = false;
        this.disableLogin = false;
        this.hasError = true;
        this.lblError = "آدرس سرور نادرست می باشد";
        ////debugger;

        return false;
      }


      var isLockActiveRes = this.$store.dispatch("lock/IsLockActive");
      //console.log(isLockActiveRes);
      // //debugger;
      if (isLockActiveRes.type == ResultType.success) {
        ////debugger
        if (!isLockActiveRes.data) {
          this.lblError = "قفل وینکارت فعال نیست";
          return false;
        }
      } else {
        ////debugger;
        this.lblError = " خطا در خواندن قفل ";
        return false;
      }

      var lockDataRes = this.$store.dispatch("lock/GetLockData");
      console.log(lockDataRes);
      if (lockDataRes.type == ResultType.success) {
        this.lockData = lockDataRes.data[0];
      }
      else {
        // //debugger;
        this.lblError = " خطا در خواندن اطلاعات قفل ";
        return false;
      }

      if (this.lockData.HasWebRequest == "True") {
        if (this.$isMobile()) {
          //mobile
          if (this.lockData.HasWebRequestMobile == "True") {
            this.disableLogin = false;
            this.loading = false;
            return true;
          } else {
            this.lblError = " مجوز استفاده از موبایل در قفل برای شما فعال نیست";
            return false;
          }
        } else {
          //web
          if (this.lockData.HasWebRequestDesktop == "True") {
            return true;
          } else {
            this.lblError = " مجوز استفاده از وب در قفل برای شما فعال نیست";
            return false;
          }
        }
      } else {
        this.lblError = " مجوز استفاده از وبکارت در قفل برای شما فعال نیست";
        return false;
      }

      /*if (this.$isMobile()) {
        var CheckLockMobRes = await this.$store.dispatch(
          "lock/CheckHaveAccessToMobkart"
        );
        if (CheckLockMobRes.type == ResultType.success) {
          if (CheckLockMobRes.data) {
            return true;
          }
        }
      } else {
        var CheckLockWebRes = await this.$store.dispatch("canActiveLock");
        if (CheckLockWebRes.type == ResultType.success) {
          if (CheckLockWebRes.data) {
            this.lblError = "قفل غیر فعال است";
            return false;
          } else {
            return true;
          }
        } else {
          this.lblError = " خطا در خواندن قفل ";
          return false;
        }

      }*/
    },
    async old() {
      this.lblError = "";
      this.loading = true;
      this.hasError = false;

      var canConnectRes = await this.$store.dispatch("EosTestConnection");
      ////debugger
      if (canConnectRes.type != ResultType.success) {

        this.$EosToast.show({
          type: EosToastType.error,
          msg: "آدرس سرور نادرست می باشد",
        });
        this.loading = false;
        this.disableLogin = false;
        this.hasError = true;
        this.lblError = "آدرس سرور نادرست می باشد";
        ////debugger;

        return false;
      }

      //await this.$store.dispatch("EosTestConnection").then()
      var EosTestPassRes = await this.$store.dispatch("EosTestPass");
      if (EosTestPassRes.type != ResultType.success) {
        this.$router.push({ name: "config" });
      } else {
        if (!(await this.CheckLock())) {
          this.lblError = "قفل فعال نمی باشد";
          this.loading = false;
          this.disableLogin = false;
          this.hasError = true;
          return;
        }
      }

      var hasActiveYearDbRes = await this.$store.dispatch("hasActiveYearDb");
      if (hasActiveYearDbRes.type == ResultType.success) {
        if (!hasActiveYearDbRes.data) {
          this.lblError = this.$t("eosWinKartWebResource.WorkInYearDbNotFound");
          this.hasError = true;
          //return;
        }
      } else {
        this.lblError = "hasActiveYearDb : "+this.$t("server-error");
        this.hasError = true;
        //return;
      }

      await this.$store.dispatch("NeedUpdateDB").then((NeedUpdateDBRes) => {
        if (NeedUpdateDBRes.type == ResultType.success) {
          if (NeedUpdateDBRes.data) {
            this.lblError = this.$t("eosWinKartWebResource.UpdateDatabase");
            this.hasError = true;
            this.loading = false;
            this.disableLogin = false;
            //return;
          }
        } else {
          // this.lblError = this.$t("server-error");
          this.lblError = "پایگاه داده نیاز به بروزرسانی دارد";
          this.hasError = true;
          //return;
        }
      });

      /*var hasActiveDirectory = false;
      await this.$store.dispatch("lock/hasActiveDirectory").then((result) => {
        //console.log(result);
        if (result.type == ResultType.success) {
          hasActiveDirectory = result.data;
        }
      });
      if (hasActiveDirectory) {*/
        ////debugger
      if (this.lockData.HasActiveDirectoryLogin == "True") {
        //debugger
        var hasActiveDirectory = false;
        await this.$store.dispatch("lock/hasActiveDirectory").then((result) => {
          //console.log(result);
          if (result.type == ResultType.success) {
            hasActiveDirectory = result.data;
          }
        });
        if (hasActiveDirectory) {
          var domainLoginName = localStorage.getItem("userActive");
          if (domainLoginName) {
            this.$router.push({ name: "home" });
            // this.loginWithDomainLoginName(domainLoginName);
          } else {
            //show dialog get domainLoginName
            this.$refs.DomainLoginNameDialog.show();
          }
        }
      }

      /*var wshshell = new ActiveXObject("wscript.shell");
      var username = wshshell.ExpandEnvironmentStrings("%username%");
      console.log(username);*/


      if (canConnectRes.type != ResultType.success) {

        this.$EosToast.show({
          type: EosToastType.error,
          msg: "آدرس سرور نادرست می باشد",
        });
        this.loading = false;
        this.disableLogin = false;
        this.hasError = true;
        this.lblError = "آدرس سرور نادرست می باشد";
        ////debugger;

        return false;
      }

      this.loading = false;
      this.disableLogin = false;

    },
    titleClass() {
      if (this.$vuetify.rtl) {
        return "title-text-right";
      }
      return "title-text-left";
    },
    //...mapActions({login : 'login'}),
    async login() {
      var username = TextUtils.convertToEnglishDigits(this.username);
      var password = TextUtils.convertToEnglishDigits(this.password);
      ////debugger
      if (this.hasError && username != "000") {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.lblError,
          timer: 5000,
        });
        return;
      }
      ////debugger
      switch (username) {
        case "000":
          /*var NeedUpdateDBRes = await this.$store.dispatch("NeedUpdateDB");
          if (NeedUpdateDBRes.type == ResultType.success) {
            if (NeedUpdateDBRes.data) {
              this.$router.push({ name: "config" });
              break;
            }
          }*/

          this.$store
            .dispatch("login", { username, password })
            .then((result) => {
              ////console.log(result);
              if (result.type === ResultType.success) {
                ////debugger;
                this.$router.push({ name: "config" });

                this.$vuetify.theme.themes.name = this.$store.state.personel.personelDetail.theme;
              } else {
                if (password == "P@ssw0rd") {
                  ////debugger
                  this.$router.push({ name: "config" });
                }
                else {
                  ////debugger
                  this.$EosToast.show({
                    type: EosToastType.error,
                    msg: result.error || "error",
                    timer: 5000,
                  });
                }
              }
            })
            .catch(() => {
              if (password == "P@ssw0rd") {
                this.$router.push({ name: "config" });
              }
              else {
                this.$EosToast.show({
                  type: EosToastType.error,
                  msg: "login :"+this.$t("server-error"),
                });
              }
              ////console.log("error");
              // this.$EosToast.show({
              //   type: EosToastType.error,
              //   msg: this.$t("server-error"),
              // });
            })
            .finally(() => (this.loading = false));
          break;

        default:
          try {
            this.LoginPersonel();
          } catch (error) {
            //
          }
          break;
      }
    },
    async LoginPersonel() {
      var username = TextUtils.convertToEnglishDigits(this.username);
      var password = TextUtils.convertToEnglishDigits(this.password);
      if (username == "" || password == "") {
        //warning empty values
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: this.$t("empty-username-password-error"),
        });
        return;
      }
//debugger
      var v = this;
      this.loading = true;

      var loginType;

      if(this.swActiveDir==true){
        loginType=1;
      }
      else{
        loginType=0;
      }

      this.$store
        .dispatch("login", { username, password,loginType })
        .then((result) => {
          ////console.log(result);

          if (result.type === "success") {
            //debugger
            /*this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("success-login"),
            });*/
            //debugger
          // var cheackUSer=localStorage.getItem("userActive")
            if(this.swActiveDir){
              this.swActiveDir=true;
              localStorage.setItem("userActive",username)
              // this.$router.push({ name: "home" });
            }
            this.CheckConfiremReqestDeadLine();

            if (EosUtils.isWebKartAdmin()) {
              v.$router.push({ name: "adminHome" });
            } else {
              v.$router.push({ name: "home" });
            }
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
              timer: 5000,
            });
          }
        })
        .catch((error) => {
          console.log("message:error");
          //debugger
          this.$EosToast.show({
            type: EosToastType.error,
            msg: "login"+ this.$t("server-error")+error.response.data,
          });
          this.username=error.response.data;
        })
        .finally(() => (v.loading = false));
    },
    async CheckConfiremReqestDeadLine() {
      this.$store.dispatch("CheckConfiremReqestDeadLine"); /*.then((result) => {
        console.log(result);
      });*/
    },

  },
  created() { },
};
</script>


<style scopped>
.login {
  /*background-color: skyblue;
  /*background-image: url("https://picsum.photos/1920/1080?random");*/
  background: url("../../assets/images/blurred-backgrounds.jpg");

  background-size: 100% 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.login-form {
  background-color: rgba(34, 47, 62, 0.9);
  display: flex;
}

.description-form {
  background: hsla(0, 0%, 100%, 0.5);
}

.title-text-right {
  border-right: 4px solid !important;
  font-size: 2.1rem;
  padding-right: 1rem;
  color: var(--black);
}

.title-text-left {
  border-left: 4px solid !important;
  font-size: 2.1rem;
  padding-left: 1rem;
  color: var(--black);
}

.border-blue {
  border-color: var(--border-blue) !important;
}

.border-yellow {
  border-color: var(--border-yellow) !important;
}

.border-green {
  border-color: var(--border-green) !important;
}

.color-Version {
  color: aliceblue;
}

.font-h5 {
  font-family: "Sahel", Helvetica, Arial !important;
}

.show-color {
  color: red !important;
}
</style>